/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerSquadElementList = {
    type: 'array',
    contains: {
        type: 'PlayerSquadElement',
    },
} as const;
